import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBOJk0sqgXPz75mGGFu12zsqMtsm2RDO6I",
  authDomain: "terror-tcg.firebaseapp.com",
  databaseURL: "https://terror-tcg-default-rtdb.firebaseio.com",
  projectId: "terror-tcg",
  storageBucket: "terror-tcg.firebasestorage.app",
  messagingSenderId: "47395896249",
  appId: "1:47395896249:web:59ae23e554366159c09468"
};

const app = initializeApp(firebaseConfig);
export const db   = getDatabase(app);
export const auth = getAuth(app);